export default __webpack_public_path__ + "static/media/boris-mask-1.f1e3d348.png";